import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Navigation from "@rocketseat/gatsby-theme-docs/src/components/Docs/PostNav";
export const _frontmatter = {
  "title": "Summary",
  "description": "A summary of LimeChain's Hashport Round  audit"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "hashport-round--security-audit",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#hashport-round--security-audit",
        "aria-label": "hashport round  security audit permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hashport Round  Security Audit`}</h1>
    <p>{`We were tasked with performing a round two audit on the cross-chain bridge implementation of LimeChain and in particular their new NFT bridge implementation containing an NFT wrapper implementation, a new token based fee system for the NFT transfers and an update across the codebase to properly track the NFT token payments for the governance committee.`}</p>
    <p>{`Over the course of the audit, we did not identify any severe vulnerabilities and the codebase has now been developed with proper standards and complying to the latest security guidelines. We observed that recommendations from our previous round are now actively applied during the development phase thus greatly increasing the quality of the codebase.`}</p>
    <p>{`We were able to pinpoint a single Diamond-standard related issue that we believe to be desired behaviour but we urge the LimeChain team to explicitly define within the code that it's desired. Additionally, a concern that can arise due to the access control around burning the wrapped NFT implementations has also been raised within the audit and needs to be addressed by the LimeChain team.`}</p>
    <p>{`Overall, the codebase of Hashport is once again of very high quality and the documentation of the project is exemplary.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Files in Scope`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Repository`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`Commit(s)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/DiamondCutFacet.sol"
            }}>{`DiamondCutFacet.sol (DCF)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/DiamondCutFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/DiamondCutFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/DiamondLoupeFacet.sol"
            }}>{`DiamondLoupeFacet.sol (DLF)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/DiamondLoupeFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/DiamondLoupeFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/ERC721PortalFacet.sol"
            }}>{`ERC721PortalFacet.sol (ERC)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/ERC721PortalFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/ERC721PortalFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/FeeCalculatorFacet.sol"
            }}>{`FeeCalculatorFacet.sol (FCF)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/FeeCalculatorFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/FeeCalculatorFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/GovernanceFacet.sol"
            }}>{`GovernanceFacet.sol (GFT)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/GovernanceFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/GovernanceFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/GovernanceV2Facet.sol"
            }}>{`GovernanceV2Facet.sol (GVF)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/GovernanceV2Facet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/GovernanceV2Facet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibERC721.sol"
            }}>{`LibERC721.sol (LER)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/libraries/LibERC721.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibERC721.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibRouter.sol"
            }}>{`LibRouter.sol (LRR)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/libraries/LibRouter.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibRouter.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibDiamond.sol"
            }}>{`LibDiamond.sol (LDD)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/libraries/LibDiamond.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibDiamond.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibPayment.sol"
            }}>{`LibPayment.sol (LPT)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/libraries/LibPayment.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibPayment.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibGovernance.sol"
            }}>{`LibGovernance.sol (LGE)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/libraries/LibGovernance.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibGovernance.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibFeeCalculator.sol"
            }}>{`LibFeeCalculator.sol (LFC)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/libraries/LibFeeCalculator.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/libraries/LibFeeCalculator.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/OwnershipFacet.sol"
            }}>{`OwnershipFacet.sol (OFT)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/OwnershipFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/OwnershipFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/PaymentFacet.sol"
            }}>{`PaymentFacet.sol (PFT)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/PaymentFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/PaymentFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/PausableFacet.sol"
            }}>{`PausableFacet.sol (PFE)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/PausableFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/PausableFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/Router.sol"
            }}>{`Router.sol (ROU)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/Router.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/Router.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/RouterFacet.sol"
            }}>{`RouterFacet.sol (RFT)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/facets/RouterFacet.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/facets/RouterFacet.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/WrappedToken.sol"
            }}>{`WrappedToken.sol (WTN)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/WrappedToken.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/WrappedToken.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/WrappedERC721.sol"
            }}>{`WrappedERC721.sol (WER)`}</a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts"
            }}>{`hashport-contracts`}</a></td>
          <td parentName="tr" {...{
            "align": "right"
          }}><a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/22c56946f798785c92294e1960e7bd77471bd2a5/contracts/WrappedERC721.sol"
            }}>{`22c56946f7`}</a>{`,`}<div></div>{` `}<a parentName="td" {...{
              "href": "https://github.com/LimeChain/hashport-contracts/blob/72ee60e280650797112e69c41d45b6b05a574741/contracts/WrappedERC721.sol"
            }}>{`72ee60e280`}</a></td>
        </tr>
      </tbody>
    </table>
    <p>{`During the audit, we filtered and validated a total of `}<strong parentName="p">{`1 findings utilizing static analysis`}</strong>{` tools as well as identified a total of `}<strong parentName="p">{`6 findings during the manual review`}</strong>{` of the codebase. We strongly recommend that any minor severity or higher findings are dealt with promptly prior to the project's launch as they introduce potential misbehaviours of the system as well as exploits.`}</p>
    <p>{`The list below covers each segment of the audit in depth and links to the respective chapter of the report:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/limechain-hashport-round-2/compilation"
        }}>{`💻 Compilation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/limechain-hashport-round-2/static-analysis"
        }}>{`🔍 Static Analysis`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/limechain-hashport-round-2/manual-review"
        }}>{`👁️ Manual Review`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/limechain-hashport-round-2/code-style"
        }}>{`🖋️ Code Style`}</a></li>
    </ul>

    <Navigation prev={null} next={{
      label: "Compilation",
      link: "/compilation"
    }} mdxType="Navigation" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      